import React from 'react';

const OptionBlock = ({ option, onDragStart, onClick, variant = 'default' }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick(option, e);
    }
  };

  const colorClasses = variant === 'drill'
    ? 'bg-gradient-to-br from-[#345d8a] to-[#1e3d6f] text-white'
    : 'bg-gradient-to-br from-[#fcb319] to-[#f5a500] text-[var(--text-primary)] dark:text-[#1d4746]';

  return (
    <div
      data-fib-option
      className={`py-2 px-4 ${colorClasses} rounded-lg text-sm font-semibold cursor-grab transition-all duration-300 select-none shadow-[0_2px_4px_rgba(252,179,25,0.2)] hover:-translate-y-0.5 hover:shadow-[0_4px_8px_rgba(252,179,25,0.3)] active:cursor-grabbing active:scale-95 max-md:py-2.5 max-md:px-3.5 max-md:text-[13px] max-md:min-h-[44px]`}
      draggable
      onDragStart={(e) => onDragStart(e, option)}
      onClick={handleClick}
    >
      {option}
    </div>
  );
};

export default OptionBlock;
